import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Button, composeRenderProps } from 'react-aria-components';
import { Size } from '../../constants/size.js';
import { twMerge } from '../../utils/twMerge.js';
export const SelectButton = forwardRef(function SelectInput({ isInvalid, size = Size.Default, ...selectButtonProps }, forwardedRef) {
    return (_jsx(Button, { ...selectButtonProps, ref: forwardedRef, "data-invalid": isInvalid || undefined, className: composeRenderProps(selectButtonProps.className, (className) => twMerge('ppl-SelectButton inline-flex appearance-none flex-row items-center justify-between gap-1 rounded border border-default bg-default px-2 py-1 shadow outline outline-1 -outline-offset-1 outline-transparent transition-[box-shadow,border-color,outline]', 
        // hover states
        'hover:border-default-hover hover:shadow-md', 
        // focus states
        'focus:outline-accent-bold focus:ring focus:ring-accent/[.38] focus:ring-offset-0', 
        // invalid states
        'invalid:border-critical', 
        // invalid hover states
        'invalid:hover:border-critical-hover', 
        // invalid focus states
        'invalid:focus:outline-critical invalid:focus:ring-critical/[.38]', 
        // disabled states
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-default-bold disabled:opacity-40 disabled:shadow-none', 
        // sizes
        {
            compact: 'h-6',
            default: 'h-8',
            loose: 'h-10',
        }[size], 
        // user styles
        className)) }));
});
//# sourceMappingURL=SelectButton.js.map